export const giCommissionImportEndpoints = (builder) => ({
  saveGICommissionBatch: builder.mutation({
    query: (body) => ({
      url: '/GeneralInsurance/commission-import/save-batch',
      method: 'POST',
      body,
    }),
    invalidatesTags: ['GICommissionImport'],
  }),
  getGICommissionBatches: builder.query({
    query: () => ({
      url: '/GeneralInsurance/commission-import/batches',
      method: 'GET',
    }),
    providesTags: ['GICommissionImport'],
  }),
  deleteGICommissionBatch: builder.mutation({
    query: (batchId) => ({
      url: `/GeneralInsurance/commission-import/delete-batch/${batchId}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['GICommissionImport'],
  }),
});
